// @ts-nocheck
import { useDebounce } from "@store/Framework/Common/Hooks/useDebounce";
import { useEffect, useState } from "react";
import { useTheme } from "styled-components";

const getCurrentBreakpointIndex = (width: number, values: number[]) => {
    let breakpointIndex;

    if (width > values[values.length - 1]) {
        return values.length - 1;
    }

    for (const [i, x] of values.entries()) {
        if (x > width) {
            breakpointIndex = i - 1;
            break;
        }
    }
    // bunzl custom code, breakpoint index will not reset to 0 on resize
    if (breakpointIndex || breakpointIndex === 0) {
        return breakpointIndex;
    }
    return null;
};
export default () => {
    const theme = useTheme();
    const { values } = theme.breakpoints;
    const [currentBreakpoint, setCurrentBreakpoint] = useState<number | null>(null);
    const onResizeHandler = () => {
        if (typeof window === "undefined") {
            return null;
        }
        const newIndex = getCurrentBreakpointIndex(document.documentElement.clientWidth, values);
        if (newIndex !== currentBreakpoint) {
            setCurrentBreakpoint(newIndex);
        }
    };
    const debouncedResizeHandler = useDebounce(onResizeHandler, 100);
    useEffect(() => {
        debouncedResizeHandler();
    }, []);

    useEffect(() => {
        window.addEventListener("resize", debouncedResizeHandler);

        return () => {
            window.removeEventListener("resize", debouncedResizeHandler);
        };
    }, []);

    if (typeof window === "undefined") {
        return null;
    }

    if (currentBreakpoint === null) {
        const firstRenderWidth = document?.documentElement?.clientWidth;
        return getCurrentBreakpointIndex(firstRenderWidth, values);
    }
    return currentBreakpoint;
};
